import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

import DataTable from '../../reusables/DataTable';
import { ColDef } from '@ag-grid-community/core';

import { IUser } from '../../../types/user'

import useGetUsers from '../../../hooks/user/useGetUsers';

import ViewsLayout from '../../layouts/ViewsLayout';

const Home = () => {
    const navigate = useNavigate();

    const [users, setUsers] = useState<IUser[]>([]);

    const { data: allUsers, isPending, isError } = useGetUsers();

    useEffect(() => {
        setUsers(allUsers ? allUsers : []);
    }, [allUsers]); //eslint-disable-line


    const columns: ColDef[] = [
        { field: "email" },
        { field: "applicant", headerName: "Full Name", valueGetter: ({ data }) => `${data?.first_name ? data.first_name : ""} ${data?.last_name ? data.last_name : ""}` },
        { field: "create_date", headerName: "Account Created", valueGetter: ({ data }) => moment(data?.create_date).format('MMM DD, YYYY HH:mm') },
        { field: "questionnaire_date", headerName: "Questionnaire Date", valueGetter: ({ data }) => data?.questionnaire_date ? moment(data.questionnaire_date).format('MMM DD, YYYY HH:mm') : '' },
        {
            width: 570, filter: false, headerName: "Status", cellRenderer: ({ data }: any) => {
                return <span style={{ display: "flex", justifyContent: "center", height: "100%", alignItems: "center" }}>
                    {data?.scores > 0 && (<div style={{ margin: 2, padding: 2, textAlign: "center", background: "#f4acff", borderRadius: 10 }}>Score {data?.scores}</div>)}
                    {data?.questionnaireStatus && (<div style={{ margin: 2, padding: 2, textAlign: "center", background: "#eddfff", borderRadius: 10 }}>{data?.questionnaireStatus}</div>)}
                    {data?.noOfPrograms > 0 && (<div style={{ margin: 2, padding: 2, textAlign: "center", background: "#ffdcf1", borderRadius: 10 }}>#{data?.noOfPrograms} of prog's</div>)}
                    <div style={{ margin: 2, padding: 2, textAlign: "center", background: "#dcf8ff", borderRadius: 10 }}>#{data?.noOfConsults} of Con's</div>
                    <div style={{ margin: 2, padding: 2, textAlign: "center", background: data?.isSubscribe ? "#bcc9f8" : "#ffcece", borderRadius: 10 }}>{data?.isSubscribe ? "Subscribe" : "Unsubscribe"}</div>
                </span>
            }
        },
    ];

    const onRowClicked = ({ data }: any) => {
        navigate(`/${data?.id}`);
    }

    if (isPending) return <div>Loading...</div>
    if (isError) return <div>Error</div>

    return (
        <ViewsLayout>
            <div className='imm_home__main_view'>
                <div className="imm_home__main_content"><DataTable data={users} columns={columns} onRowClicked={onRowClicked} paginationPageSize={200} /></div>
            </div>
        </ViewsLayout>
    );
}

export default Home;